
export enum InvoiceType {
  PhysicalPerson = 'PhysicalPerson',
  LegalEntity = 'LegalEntity'
}

export function getInvoiceTypeIdentifier(invoiceType: InvoiceType): string {
  switch(invoiceType) {
    case InvoiceType.PhysicalPerson:
      return 'PP';
    case InvoiceType.LegalEntity:
      return 'LE';
  }
}
